<h2 mat-dialog-title style="white-space: nowrap">Manage Account Roles for {{selectedUser.userName}} </h2>
<mat-dialog-content>
  <h3 style="margin:0px">Selected Account: {{selectedAccountName}}</h3>
  <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center;">
    <mat-form-field style="align-content: flex-end; width:35%" *ngIf="userTypes">
      <mat-label>User Type</mat-label>
      <mat-select [(value)]="selectedUserType" (selectionChange)="changeUserType($event)">
        <mat-option *ngFor="let userType of userTypes" [value]="userType.guid">
          <div>{{userType.name}}</div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row" *ngIf="selection">
    <div style="flex: 1 1 0%; box-sizing: border-box;">
      <mat-selection-list class="list" style="text-align: left;" (selectionChange)="changeAccountIds($event)">
        <mat-list-option [value]="roleGuid.AccountFeatureSet" [selected]="selection.isSelected(roleGuid.AccountFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">AccountFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.AuditDocFeatureSet" [selected]="selection.isSelected(roleGuid.AuditDocFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">AuditDocFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.DeleteDocFeatureSet" [selected]="selection.isSelected(roleGuid.DeleteDocFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">DeleteDocFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.DocReviewFeatureSet" [selected]="selection.isSelected(roleGuid.DocReviewFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">DocReviewFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.EditFeatureSet" [selected]="selection.isSelected(roleGuid.EditFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">EditFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.EditMetadataFeatureSet" [selected]="selection.isSelected(roleGuid.EditMetadataFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">EditMetadataFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.LimitedFeatureSet" [selected]="selection.isSelected(roleGuid.LimitedFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">LimitedFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.ManageCustomDocFieldsFeatureSet" [selected]="selection.isSelected(roleGuid.ManageCustomDocFieldsFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">ManageCustomDocFieldsFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.PowerUploadFeatureSet" [selected]="selection.isSelected(roleGuid.PowerUploadFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">PowerUploadFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.PredictiveCodingFeatureSet" [selected]="selection.isSelected(roleGuid.PredictiveCodingFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">PredictiveCodingFeatureSet</span>
        </mat-list-option>
        <mat-list-option [value]="roleGuid.StandardFeatureSet" [selected]="selection.isSelected(roleGuid.StandardFeatureSet)">
          <span matListItemTitle style="display: flex; align-items: center;">StandardFeatureSet</span>
        </mat-list-option>
      </mat-selection-list>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
  <button mat-raised-button color="primary" id="submitManageAccountRolesForm" [disabled]="!formChanged || selection.selected.length === 0" (click)="submit()">Submit</button>
  <button mat-raised-button color="secondary" mat-dialog-close>Cancel</button>
</mat-dialog-actions>
